import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import { getFields, isForm } from './schemaUtils.esm.js';
import validate from './validate.esm.js';

var stateFromSchema = function stateFromSchema(schema, state) {
  if (state === void 0) {
    state = {};
  }

  return getFields(schema).reduce(function (result, _ref) {
    var _extends2;

    var name = _ref[0],
        field = _ref[1];
    return _extends({}, result, (_extends2 = {}, _extends2[name] = isForm(field) ? stateFromSchema(field, state[name]) : state[name], _extends2));
  }, {});
};
var getInitialValues = function getInitialValues(schema, initialValues) {
  if (initialValues === void 0) {
    initialValues = {};
  }

  return stateFromSchema(schema, initialValues);
};

var populateRecursively = function populateRecursively(schema, value) {
  return getFields(schema).reduce(function (result, _ref2) {
    var _extends3;

    var name = _ref2[0],
        field = _ref2[1];
    return _extends({}, result, (_extends3 = {}, _extends3[name] = isForm(field) ? populateRecursively(field, value) : value, _extends3));
  }, {});
};

var getInitialTouched = function getInitialTouched(schema, validateOnInit) {
  return populateRecursively(schema, validateOnInit);
};
var getInitialVisited = function getInitialVisited(schema) {
  return populateRecursively(schema, false);
};
var getAllFieldsTouched = function getAllFieldsTouched(schema) {
  return populateRecursively(schema, true);
};
var mergeAdditionalErrors = function mergeAdditionalErrors(validationResult, additionalErrors) {
  if (validationResult === void 0) {
    validationResult = [true];
  }

  if (additionalErrors === void 0) {
    additionalErrors = {};
  }

  return Object.keys(additionalErrors).reduce(function (_ref3, errorKey) {
    var _extends4;

    var isValid = _ref3[0],
        errors = _ref3[1];
    var error = additionalErrors[errorKey];
    var additionalValidationResult = typeof error === 'object' ? mergeAdditionalErrors(errors == null ? void 0 : errors[errorKey], additionalErrors[errorKey]) : error ? [false, error] : [true];
    return [isValid && additionalValidationResult[0], _extends({}, errors, (_extends4 = {}, _extends4[errorKey] = additionalValidationResult, _extends4))];
  }, validationResult);
};
var getValidationResult = function getValidationResult(schema, values, touched, additionalErrors, validate$1) {
  if (validate$1 === void 0) {
    validate$1 = validate;
  }

  var validationResult = validate$1(schema, values, touched);
  return additionalErrors !== undefined ? mergeAdditionalErrors(validationResult, additionalErrors) : validationResult;
};

export { getAllFieldsTouched, getInitialTouched, getInitialValues, getInitialVisited, getValidationResult, mergeAdditionalErrors, stateFromSchema };
//# sourceMappingURL=utils.esm.js.map
